/**
 * Custom Chakra UI Theme - Apple-Clean Aesthetic
 */

import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';
import { colors, shadows, radii, typography } from './tokens';

const customConfig = defineConfig({
  theme: {
    tokens: {
      colors: {
        // Brand colors
        brand: {
          50: { value: '#E6F2FF' },
          100: { value: '#CCE5FF' },
          200: { value: '#99CBFF' },
          300: { value: '#66B0FF' },
          400: { value: '#3396FF' },
          500: { value: colors.primary },
          600: { value: colors.primaryHover },
          700: { value: colors.primaryActive },
          800: { value: '#004999' },
          900: { value: '#003166' },
        },
        // Gray scale (Apple-inspired)
        gray: {
          50: { value: '#FAFAFA' },
          100: { value: colors.surface },
          200: { value: colors.border },
          300: { value: '#D1D1D6' },
          400: { value: colors.textTertiary },
          500: { value: colors.textSecondary },
          600: { value: '#6E6E73' },
          700: { value: '#48484A' },
          800: { value: colors.sidebarHover },
          900: { value: colors.sidebar },
          950: { value: '#0D0D0D' },
        },
      },
      fonts: {
        heading: { value: typography.fonts.heading },
        body: { value: typography.fonts.body },
      },
      radii: {
        sm: { value: radii.sm },
        md: { value: radii.md },
        lg: { value: radii.lg },
        xl: { value: radii.xl },
      },
      shadows: {
        sm: { value: shadows.sm },
        md: { value: shadows.md },
        lg: { value: shadows.lg },
      },
    },
    semanticTokens: {
      colors: {
        // Background
        'bg.canvas': { value: colors.background },
        'bg.surface': { value: colors.surface },
        'bg.muted': { value: colors.surfaceHover },
        
        // Border
        'border.default': { value: colors.border },
        'border.muted': { value: colors.borderLight },
        
        // Text
        'fg.default': { value: colors.textPrimary },
        'fg.muted': { value: colors.textSecondary },
        'fg.subtle': { value: colors.textTertiary },
        
        // Primary
        'colorPalette.solid': { value: colors.primary },
        'colorPalette.contrast': { value: colors.textInverse },
        'colorPalette.fg': { value: colors.primary },
        
        // Status colors
        'success.fg': { value: colors.success },
        'success.subtle': { value: colors.successBg },
        'warning.fg': { value: colors.warning },
        'warning.subtle': { value: colors.warningBg },
        'error.fg': { value: colors.error },
        'error.subtle': { value: colors.errorBg },
      },
    },
  },
  globalCss: {
    'html, body': {
      bg: 'bg.canvas',
      color: 'fg.default',
      fontFamily: 'body',
    },
    '*::selection': {
      bg: 'brand.100',
      color: 'brand.700',
    },
  },
});

export const system = createSystem(defaultConfig, customConfig);

